export function isArray<TMaybeArray>(arr: TMaybeArray): arr is Extract<TMaybeArray, Readonly<unknown[]> | unknown[]> {
  return Array.isArray(arr)
}
